import Endpoints from '../endpoints';
import { axiosInstance } from '../instance';

export const getUpdateStatus = async () => {
  try {
    const res = await axiosInstance.get(Endpoints.STATISTIC.GET_UPDATE_STATUS);
    if (!res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось получить статус обновления' };
  }
};

export const getGoodsPrices = async () => {
  try {
    const res = await axiosInstance.get(Endpoints.STATISTIC.GET_GOODS_PRICES, {
      params: { skip: 0, limit: 100000 },
    });
    if (res.data && !res.data.error) {
      return res.data;
    } else {
      throw new Error();
    }
  } catch (e) {
    console.log(e);
    return { error: 'Не удалось получить данные по ценам' };
  }
};

const statistic = {
  getUpdateStatus,
  getGoodsPrices,
};

export default statistic;
